<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M32.908 6.248a1 1 0 00-1.816 0L23.32 23.087l-18.128 2.59A1 1 0 004.7 27.44l14.158 11.583-5.153 18.035a1 1 0 001.486 1.126L32 47.841l16.809 10.344a1 1 0 001.486-1.126l-5.153-18.035L59.3 27.441a1 1 0 00-.492-1.764l-18.128-2.59-7.772-16.84z"/></svg>